import React, { useEffect, useRef } from 'react'
import { EmptyMassage, FeedLoadBar } from './comps'

const displayUrl = (link, host) => {
  try {
    const url = new URL(link)
    const parts = [host || url.hostname.replace(/^www\./, '')]
    url.pathname.split('/').filter(Boolean).slice(0, 2).forEach(part => parts.push(decodeURIComponent(part)))
    return parts.join(' › ')
  } catch (err) {
    return host || link
  }
}

const WebResults = ({ items, isload, emptyTitle, onMore }) => {
  const scrollerRef = useRef(null)
  const fetching = useRef(false)

  useEffect(() => {
    fetching.current = false
  }, [items.length])

  useEffect(() => {
    const node = scrollerRef.current
    if (!node || !onMore) return undefined
    const onScroll = () => {
      if (fetching.current || isload) return
      if (node.scrollTop + node.clientHeight + 80 >= node.scrollHeight) {
        fetching.current = true
        onMore()
      }
    }
    node.addEventListener('scroll', onScroll)
    return () => node.removeEventListener('scroll', onScroll)
  }, [isload, onMore, items.length])

  return (
    <div ref={scrollerRef} className="webResults">
      {isload && !items.length ? <FeedLoadBar /> : null}
      {!isload && !items.length ? <EmptyMassage title={emptyTitle} /> : null}
      {items.map((item, index) => (
        <a
          key={`${item.link}-${index}`}
          className="webResult"
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="webResultSite">
            <img
              src={`https://www.google.com/s2/favicons?domain=${encodeURIComponent(item.host || item.link)}&sz=32`}
              alt=""
              draggable="false"
            />
            <span>
              <strong>{item.host || displayUrl(item.link)}</strong>
              <em>{displayUrl(item.link, item.host)}</em>
            </span>
          </span>
          <span className="webResultTitle">{item.title}</span>
          {item.snippet ? <span className="webResultSnippet">{item.snippet}</span> : null}
        </a>
      ))}
      {isload && items.length ? <FeedLoadBar /> : null}
    </div>
  )
}

export default WebResults
